import ImgSlider from './slider.es6';

export default class Main {
    constructor() {
        this.ImgSlider = new ImgSlider();
        // this.init();
    }

    init() {}
}
